import * as React from "react";

function SvgWindowCloseLine(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      style={{
        msTransform: "rotate(360deg)",
        WebkitTransform: "rotate(360deg)",
      }}
      transform="rotate(360)"
      {...props}
    >
      <path
        d="M19.41 18l7.29-7.29a1 1 0 00-1.41-1.41L18 16.59l-7.29-7.3A1 1 0 009.3 10.7l7.29 7.3-7.3 7.29a1 1 0 101.41 1.41l7.3-7.29 7.29 7.29a1 1 0 001.41-1.41z"
        className="window-close-line_svg__clr-i-outline window-close-line_svg__clr-i-outline-path-1"
        fill="#626262"
      />
      <path fill="rgba(0, 0, 0, 0)" d="M0 0h36v36H0z" />
    </svg>
  );
}

export default SvgWindowCloseLine;

